var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patrolPlanDetails commonWrap"},[_c('div',{staticStyle:{"width":"98%","height":"97%"}},[_c('OriginalTable',{attrs:{"tableList":_vm.tableData,"tableHead":_vm.tabHead}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }